export default __webpack_public_path__ + "static/map-cc9b79ca96106676e28a3127ccca2523.jpg";